import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";
import { ContentSidebar } from "@/components/marketing/ContentSidebar";

export const Route = createFileRoute('/use-cases')({
  component: UseCasesLayout,
});

const useCasesSidebar = {
  title: "Use Cases",
  sections: [
    {
      items: [
        { label: "Overview", href: "/use-cases" },
      ]
    },
    {
      title: "Solutions",
      items: [
        { label: "API Management", href: "/use-cases/api-management", iconName: "Router" },
        { label: "FinOps & Cost", href: "/use-cases/finops", iconName: "DollarSign" },
        { label: "Data Synchronization", href: "/use-cases/data-synchronization", iconName: "RefreshCw" },
        { label: "AI Automation", href: "/use-cases/ai-automation", iconName: "Bot" },
        { label: "Enterprise Security", href: "/use-cases/enterprise-security", iconName: "Shield" },
      ]
    }
  ]
};

function UseCasesLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="container px-6 py-12">
        <div className="flex gap-12">
          <ContentSidebar
            title={useCasesSidebar.title}
            sections={useCasesSidebar.sections}
          />
          <main className="flex-1 min-w-0">
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
}
